import React from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_VALUE } from '@/constants'
import { toastFactory } from '@/factories'
import { ChecklistInput } from '@/models'
import { downloadHref, getFilenameFromUrl } from '@/utils/file'

import { ChecklistProviderCard } from '../checklist-provider-card/checklist-provider-card'
import {
  getNestedFormCount,
  isChecklistInputTypeFileUpload,
  isChecklistInputTypeForm,
  isChecklistInputTypeProvidersInfo,
  isChecklistInputTypeSimple,
  isChecklistInputTypeTextInfo,
  isChecklistInputTypeVehicleForm,
} from '../checklists-task.page.utils'
import * as S from './checklist-task-answer.styled'

interface ChecklistTaskAnswerProps {
  input: ChecklistInput
}

export const ChecklistTaskAnswer = ({ input }: ChecklistTaskAnswerProps) => {
  const { t } = useTranslation(['checklists'])

  if (isChecklistInputTypeForm(input)) {
    const nestedFormCount = getNestedFormCount(input)

    return t('checklists:task.answer.formProgress', {
      completed: nestedFormCount,
      total: input.formMaxEntries,
    })
  }

  if (isChecklistInputTypeVehicleForm(input)) {
    const nestedFormCount = getNestedFormCount(input)

    return t('checklists:task.answer.formProgress', {
      completed: nestedFormCount,
      total: input.formMaxEntries,
    })
  }

  if (isChecklistInputTypeProvidersInfo(input)) {
    return (
      <S.ProvidersContainer>
        {input.providersInfo.map((providerInfo) => (
          <ChecklistProviderCard key={providerInfo.id} providerInfo={providerInfo} />
        ))}
      </S.ProvidersContainer>
    )
  }

  if (isChecklistInputTypeSimple(input)) {
    if (isChecklistInputTypeFileUpload(input)) {
      const fileUrl = input.answers[0]

      if (!fileUrl) {
        return EMPTY_VALUE
      }

      const fileName = getFilenameFromUrl(fileUrl)

      const handleDownload = async () => {
        try {
          await downloadHref(fileUrl, fileName)
        } catch {
          toastFactory.error(t('checklists:task.downloadError'))
        }
      }

      return (
        <S.FileDownloadButton type="button" onClick={handleDownload}>
          {fileName}
        </S.FileDownloadButton>
      )
    }

    if (isChecklistInputTypeTextInfo(input)) {
      return <S.InnerHtmlContainer dangerouslySetInnerHTML={{ __html: input.textInfo }} />
    }

    return input.answers?.join(', ')
  }

  return EMPTY_VALUE
}
